import {Map} from "immutable";

export function formatSubscriptionStatus(subscription = Map()) {
  switch(subscription.get("status")) {
    case "active": return "Active";
    case "paused": return "Paused";
    case "pause_deferred": return "Will Pause";
    case "cancelled": return "Cancelled";
    case "cancellation_deferred": return "Will Cancel";
    default:
      return subscription.get("status", "");
  }
}

export function isSubscriptionActive(subscription = Map()) {
  return subscription.get("status") === "active";
}
export function isSubscriptionPaused(subscription = Map()) {
  return subscription.get("status") === "paused";
}
export function isSubscriptionPauseDeferred(subscription = Map()) {
  return subscription.get("status") === "pause_deferred";
}
export function isSubscriptionCancelled(subscription = Map()) {
  return subscription.get("status") === "cancelled";
}
export function isSubscriptionCancellationDeferred(subscription = Map()) {
  return subscription.get("status") === "cancellation_deferred";
}

export function canCancelSubscription(subscription = Map()) {
  return isSubscriptionActive(subscription) || isSubscriptionPaused(subscription) || isSubscriptionPauseDeferred(subscription);
}
export function canUndoCancelSubscription(subscription = Map()) {
  return isSubscriptionCancellationDeferred(subscription);
}
export function canUndoPauseSubscription(subscription = Map()) {
  return isSubscriptionPauseDeferred(subscription);
}
export function canPauseSubscription(subscription = Map()) {
  return isSubscriptionActive(subscription);
}
export function canRestartSubscription(subscription = Map()) {
  return isSubscriptionPaused(subscription);
}
